<template>
  <transition name="fade">
    <div class="pnlDialogFull" v-show="show" style="animation-duration: 0.3s">
      <div class="pnlDialogGray" @click.self="CloseDialog">
        <div class="pnlDialogAddLecture">
          <div class="pnlTitleBar">
            <label>新增課程</label>
            <img class="btnDialogXX" src="@/assets/img/icon_btn/btn_close.png" @click="CloseDialog" />
          </div>
          <div class="pnlContent">
            <div class="subTitle">課程</div>
            <select v-model="selectSerial" class="ddlAddLecture">
              <option selected="true" disabled="disabled">課程名稱</option>
              <option v-for="option in LecturesOption" :key="option.serial" :value="option.serial">
                {{ option.name }}
              </option>
            </select>
            <div class="subTitle">到期日</div>
            <datepicker
              v-model="selectExpireDate"
              format="YYYY-MM-DD"
              value-type="format"
              placeholder="Select date"
              class="editExpire"
            ></datepicker>

            <div class="pnlBtnArea">
              <button class="btnAddConfirm" @click="AddLectureUI">新增</button>
              <button class="btnAddCancel" @click="CloseDialog">取消</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import datepicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { apiGetLectureList, apiAdminNewCourse } from '@/request.js';
export default {
  name: 'DialogAddLecture',
  props: {
    show: Boolean,
    serial: Number,
    lecture: Array,
    account: String,
  },
  data() {
    return {
      LecturesOption: [],
      selectSerial: '課程名稱',
      selectExpireDate: null,
    };
  },
  mounted() {
    // this.LecturesOption = [
    //   { serial: 3, name: 'VR教具酷' },
    //   { serial: 4, name: '英語拼字小鬥士' },
    //   { serial: 5, name: '單字找找看-市場' },
    //   { serial: 6, name: '單字找找看-居家' },
    // ];

    apiGetLectureList().then((res) => {
      if (res.data != null) {
        //console.log(JSON.stringify(res.data));
        this.LecturesOption = res.data.data;
      } else {
        this.LecturesOption = [];
      }
    });
  },
  methods: {
    CloseDialog() {
      this.selectSerial = '課程名稱';
      this.selectExpireDate = '';
      this.$emit('close-dialog');
    },
    CheckAddLecture() {
      if (this.selectSerial == '課程名稱') {
        return '請選擇課程';
      } else if (this.selectExpireDate == null) {
        return '請選擇使用期限';
      } else {
        //console.log(JSON.stringify(this.lecture));
        let indexOfLecture = this.LecturesOption.findIndex((obj) => obj.serial == this.selectSerial);
        let lectureName = this.LecturesOption[indexOfLecture].name;

        let indexOf = this.lecture.findIndex((obj) => obj.name == lectureName);
        if (indexOf >= 0) {
          return '新增失敗, 無法重複新增課程';
        } else {
          return '';
        }
      }
    },
    AddLectureUI() {
      let chkResult = this.CheckAddLecture();
      if (chkResult == '') {
        let indexOf = this.LecturesOption.findIndex((obj) => obj.serial == this.selectSerial);
        let lectureName = this.LecturesOption[indexOf].name;

        let data = {
          serial: this.selectSerial,
          name: lectureName,
          expire: this.selectExpireDate,
          account: this.account,
        };
        apiAdminNewCourse(data).then((res) => {
          //console.log(JSON.stringify(res.data));
          if (res.data != null && res.data.status == 'ok') {
            data.serial = res.data.serial;
            this.$emit('add-lecture', data);
            this.CloseDialog();
            this.$toasted.show(`${data.name} 課程新增完成。`, {
              icon: 'check',
              position: 'bottom-center',
              duration: 2500,
            });
          } else {
            this.$toasted.show(`新增失敗, ${JSON.stringify(res.data)}`, {
              icon: 'check',
              position: 'bottom-center',
              duration: 2500,
            });
          }
        });
      } else {
        this.$toasted.show(chkResult, {
          icon: 'warning',
          position: 'bottom-center',
          duration: 2500,
        });
      }
    },
  },
  components: {
    datepicker,
  },
};
</script>